/**
 * §P.10 · El marco de «Competición».
 *
 * Dos pestañas: los campeonatos y las licencias. **La segunda no se le enseña al
 * entrenador**, y es la única excepción de esta sección: sus tres rutas declaran
 * `own` y `adm` porque son papeles y dinero. En todo lo demás el entrenador entra —
 * es quien lleva a los niños el sábado.
 */
import { Link, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { vistasDeCompeticionPara } from '@/club/secciones';
import { useContextoDelClub } from '@/club/contexto';
import { puedeVerCompeticion } from '@/club/permisos';

export function MarcoDeCompeticion() {
  const camino = useRouterState({ select: (s) => s.location.pathname });
  const { rol } = useContextoDelClub();

  if (!puedeVerCompeticion(rol)) return <Navigate to="/alumnos" replace />;

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas de competición">
        {vistasDeCompeticionPara(rol).map((v) => {
          const destino = `/competicion/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
